import { ActivationStatus } from "@/enums";
import { IActivation, IActivationComment, IActivationUser, IActivationUserPermission, IUpsertActivationUsers } from "@/models";

import { BaseRepository } from "@/repositories/BaseRepository";
import { AxiosResponse } from "axios";

class ActivationRepository extends BaseRepository<IActivation> {
    constructor() {
        super("/Activations");
    }

    public getActivations(): Promise<IActivation[]> {
        const path = "Activations";

        return this.getAll({}, path);
    }

    public getActivationById(id: string): Promise<IActivation> {
        const path = `${id}`;

        return this.getOne(path);
    }

    // TODO Move to influencer repo?
    public getInfluencersFileTemplate(): Promise<AxiosResponse> {
        const path = "/InfluencerTemplate";
        return this.downloadFile(path);
    }

    // TODO Move to influencer repo?
    public getInfluencersFile(blobName: string): Promise<AxiosResponse>{
        const path = `/Influencers/${blobName}`;
        return this.downloadFile(path);
    }

    public updateProviderAccess(id: string, canAccess: boolean): Promise<boolean> {
        const path = `${id}/canProviderAccess`;
        return this.put<boolean>(path, canAccess);
    }

    public updateStatusToLive(id: string): Promise<ActivationStatus> {
        const path = `${id}/isLive`;
        return this.post<ActivationStatus>(path);
    }

    public deleteActivation(id: string): Promise<ActivationStatus> {
        const path = `${id}/delete`;
        return this.delete<ActivationStatus>(path);
    }

    public getActivationUsers(id: number): Promise<IActivationUser[]>{
        const path = `${id}/activation/users`;
        return this.get<IActivationUser[]>(path);
    }

    // TODO changer le path et le name de la methode
    public upsertActivationUser(upsertActivation: IUpsertActivationUsers): Promise<IActivationUser[]>{
        const path = `${upsertActivation.activationId}/activation/users`;
        return this.post<IActivationUser[]>(path, upsertActivation.users);
    }
}

const activationRepository = new ActivationRepository();

export { ActivationRepository, activationRepository };
